import { IconBase } from "./iconBase.js";
import { Fragment, jsx, jsxs } from "@emotion/react/jsx-runtime";
//#region src/fileDefault.tsx
var FileDefault = ({ type, ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: type === "stroke" ? /* @__PURE__ */ jsx("path", {
		d: "M12.75 3.25006V7.25006C12.75 8.35463 13.6454 9.25006 14.75 9.25006H18.75M6.75 2.75006H11.9216C12.452 2.75006 12.9607 2.96077 13.3358 3.33585L18.6642 8.66427C19.0393 9.03935 19.25 9.54806 19.25 10.0785V19.2501C19.25 20.3546 18.3546 21.2501 17.25 21.2501H6.75C5.64543 21.2501 4.75 20.3546 4.75 19.2501V4.75006C4.75 3.64549 5.64543 2.75006 6.75 2.75006Z",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinejoin: "round"
	}) : /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx("path", {
		d: "M12 2.00006H6.75C5.23122 2.00006 4 3.23128 4 4.75006V19.2501C4 20.7688 5.23122 22.0001 6.75 22.0001H17.25C18.7688 22.0001 20 20.7688 20 19.2501V10.0001H14.75C13.2312 10.0001 12 8.76884 12 7.25006V2.00006Z",
		fill: "currentColor"
	}), /* @__PURE__ */ jsx("path", {
		d: "M19.5566 8.50006C19.5343 8.47506 19.5112 8.45064 19.4874 8.42684L13.5732 2.51262C13.5494 2.48882 13.525 2.46577 13.5 2.44349V7.25006C13.5 7.94042 14.0596 8.50006 14.75 8.50006H19.5566Z",
		fill: "currentColor"
	})] })
});
//#endregion
export { FileDefault };
